module.exports = __webpack_public_path__ + "static/img/button.8d573ba8.png";